import { useMemo } from 'react';
import _ from 'lodash';
import FilterDropdown from '../FilterDropdown';
import { useFilterContext } from '../../contexts/FilterContext';
import { captureEvent } from '../../utils/analytics';

const SectionGroupsFilterDropdown = ({ sectionGroups }) => {
  const {
    state: { sectionGroupId },
    updateFilter,
  } = useFilterContext();

  const sectionGroupOptions = useMemo(
    // Sort alphabetically by name
    () => _.sortBy(sectionGroups, 'name'),
    [sectionGroups],
  );

  const selectedSectionGroup = useMemo(
    () =>
      sectionGroupId
        ? sectionGroups.find((sg) => sg.id === sectionGroupId) || {
            // If there is a section group filter but it doesn't match any
            // of the section groups, show the filter as "Select sections"
            // so the user can choose another option to recover.
            name: 'Select',
          }
        : null,
    [sectionGroupId, sectionGroups],
  );

  return (
    <FilterDropdown
      options={sectionGroupOptions}
      setOption={(value) => {
        if (value.id) {
          updateFilter('crop', '');
        }
        updateFilter('sectionGroupId', value.id || value);
        captureEvent('section-group-econ-filter');
      }}
      selectedOption={selectedSectionGroup?.name}
      optionsTitle="section group"
      allOptionsTitle="all sections"
      className="mx-2"
    />
  );
};

export default SectionGroupsFilterDropdown;
